import { useState, useEffect } from 'react';
import QueueService from '../../../Queue/service';

export function useGetQueuesTelephony(params = {}) {
  const [queuesTelephony, setQueuesTelephony] = useState([]);

  useEffect(() => {
    QueueService.getAll(null, null, false, '', params)
      .then((response) => {
        setQueuesTelephony(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []); 

  return {
    queuesTelephony,
    setQueuesTelephony
  };
}